export default {
  message: {
    'points-importer': {
      new: 'Neuer Import',
      title: 'Punkte Importer',
      label: 'Datei mit Punkten',
      undo: 'Zurücksetzen ({points} Punkte)',
      undo_less: 'Zurücksetzen',
      repair_invalid_entries: 'Ungültige Einträge reparieren ({points} Punkte)',
      recalculate: 'Neu berechnen ({points} Punkte)',
      abort: 'Abbrechen',
      upload: 'Upload ({points} Punkte)',
      downloadSelected: 'Ausgewählte Einträge herunterladen',
      addRow: 'Zeile hinzufügen',
      'select-year': 'Importjahr auswählen',
      'select-importer': 'Importer auswählen',
      'importer-type': 'Importer-Typ',
      'import-name': 'Importbezeichnung',
      'switch-point-type': 'Manuelle Eingabe aktivieren',
      progress: {
        upload: 'Upload',
        repairing: 'Repariere ungültige Einträge',
        calculating: 'Berechnung',
        validating: 'Validierung',
        loading: 'Lade Importdaten',
      },
      configurableFields: {
        title: 'Benutzerdefinierte Felder',
        description: 'Konfiguriere, in welcher Spalte die jeweiligen Informationen liegen. Bspw. Kundennummer = B',
        options: {
          emptyOption: 'Modus wählen (Standard: Direkt)',
          mode: {
            merge: 'Merge (IPC, oder Brand & Rim nötig!)',
            addition: 'Additiv (IPC, oder Brand & Rim nötig!)',
            direct: 'Direkt',
          }
        },
        headlines: {
          mode: 'Modus',
          sheet: 'Arbeitsblatt',
          columns: 'Spalten',
        },
        fields: {
          mode: 'Modus',
          importAll: 'Alles importieren',
          worksheetIndex: 'Arbeitsblatt Nummer',
          skipRows: 'Zeilen überspringen',
          headerRow: 'Header-Zeile',
          firstData: 'Erste Zeile mit Daten',
          Quantity: 'Anzahl',
          Rim: 'Zoll',
          Brand: 'Marke',
          IPC: 'IPC',
          Date: 'Datum',
          CustomerNumber: 'Kundennummer',
        }
      },
      historyStatus: {
        failed: 'Berechnung abgebrochen',
        pending: 'Noch nicht berechnet',
        completed: 'Berechnet',
        calculated: 'Berechnet (Validierung ausstehend)',
        invalid_points: 'Ungültige Berechnung',
      },
      table: {
        index: '',
        customerNumber: 'Kundennummer',
        pointsInList: 'Bestandspunkte',
        user: 'Kunde',
        points: 'Punkte aus der Liste',
        adds: 'Punkte neu',
        added: 'Punkte hinzugefügt',
        actions: 'Aktionen',
      },
      item: {
        customer_number: 'Kundennummer',
        brand: 'Marke',
        rim: 'Zoll',
        quantity: 'Anzahl',
        dealer_id: 'Händler ID',
        points_pending: 'Punkte zur Berechnung',
        points_completed: 'Berechnete Punkte',
        points_invalid_points: 'Vorgesehene Punkte',
        status: 'Status',
        imported_points: 'Importierte Punkte',
        actions: 'Aktionen',
      },
      itemStatus: {
        pending: 'Ausstehend',
        merged: 'Bereits importiert',
        calculating: 'Berechnung ausstehend',
        calculated: 'Berechnet',
      },
      alert: {
        success: 'Punkte wurden erfolgreich importiert',
      },
      details: {
        reset: {
          title: 'Punkte zurücksetzen',
          question: 'Sollen wirklich alle Punkte zurückgesetzt werden? Die Punkte können im Anschluss erneut berechnet werden.',
        }
      },
      'details-modal': {
        title: 'Import details',
        error: {
          header: {
            message: 'Message',
            data: 'Data',
            attribute: 'Attribute',
            value: 'Value',
          },
        },
        data: {
          brand: 'Marke',
          rim: 'Zollgröße',
          quantity: 'Anzahl',
          points: 'Punkte',
          points_per_item: '{points} Punkte / Item',
          customer_number: 'Kundennummer',
        },
      },
      list: {
        header: {
          points: 'Punkte',
          historyStatus: 'Status',
        },
        deleteImport: 'Import löschen',
        deleteImportConfirm: 'Sind Sie sicher, dass Sie diesen Import löschen möchten?'
      },
      show: {
        header: {
          importer_points: 'Importer Punkte',
          actual_points: 'Bereits importierte Punkte',
          expected_points: 'Punkte nach Import',
          imported_points: 'Importierte Punkte',
          delta_points: 'Unterschied',
        },
      },
      settings: {
        title: 'Importer Einstellungen',
        mode: 'Mode',
        modes: {
          merge: 'Merge',
          addition: 'Additiv',
          direct: 'Direkter Import ohne Adex einträge',
        },
        skipRows: 'Zeilen überspringen',
        headerRow: 'Header-Zeile',
        firstRow: 'Erste Zeile mit Daten',
        allData: 'Auch Daten ohne Händler importieren',
        workSheet: 'Worksheet / Arbeitsblatt',
        columnSet: 'Spaltenset: {type}',
        columns: 'Spalten',
        columnConfiguration: 'Spaltenkonfiguration',
        columnData: {
          title: 'Spaltenkonfiguration / Verarbeitung:',
          description: 'Damit der Importer funktioniert, nutzen wir eine beliebige bzw. ungenutzte Zelle um sie mit Daten zu überschreiben, falls bspw. Brand nicht angegeben wird.',
        },
        parseColumnData: {
          title: 'Spalten anhand Muster verarbeiten:',
          description: 'Beispiel: <code>R(\d{2})</code> sucht nach R00 - R99 in einer Zeichenkette und gibt die Zahl zurück. Damit können wir die Zollgröße auslesen.',
        },
        replaceColumnData: {
          title: 'Inhalte ersetzen:',
          description: 'In manchen Zellen steht bspw. <code>Bridgestone</code>, was vor dem Import in <code>bs</code> umgewandelt werden muss.',
        },
      }
    },
    'points-importer-types': {
      list: {
        table: {
          name: 'Name',
          description: 'Beschreibung',
        },
      },
    },
    menu: {
      'points-importer': 'Punkteimporter',
      'points-importer-config-importers': 'Konfiguration',
      'points-importer-import': 'Import',
      'points-importer-import-history': 'Import Historie',
    },
    breadcrumb: {
      'points-importer': 'Punkteimporter',
      'points-importer-config-importers': 'Konfiguration',
      'points-importer-config-edit-importer': 'Konfiguration editieren',
      'points-importer-import': 'Import',
      'points-importer-import-history': 'Import Historie',
      'points-importer-import-new': 'Neuer Import',
      'points-importer-import-show': 'Import anzeigen',
    },
  },
}
